import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectNewbuildingUrl = (state: IApplicationState): string => {
  const { url } = selectNewbuilding(state);

  return url;
};
